/* eslint-disable react/no-direct-mutation-state */
import React, { Fragment } from "react";
import MaterialTable from "material-table";
import { authCheckState } from "../../../store/actions/auth";
import { mainLink } from "../../../store/utils";
import axios from "axios";
import Tooltip from "@material-ui/core/Tooltip";
import Loading from "../../../components/Loading/index";
import { MTableToolbar } from "material-table";
import { connect } from "react-redux";
import { Button } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import { Link } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Snackbar } from "@material-ui/core";
import MuiAlert from "@material-ui/lab/Alert";
import {
  postBookEdition,
  getBookEdition,
  deleteBookEdition,
  editBookEdition,
} from "../../../store/actions/book";
import { compose } from "redux";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import { Redirect } from "react-router";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const useStyles = (theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
      width: "20ch",
    },
  },
});

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

class Component extends React.Component {
  state = {
    data: [],
    trainings: [],
    formDisplay: false,
    loading: false,
    showPrintDialog: false,
    showCsvPrintDialog: false,
    showEmailDialog: false,
    downloadAllTraining: false,
    extramail: "",
    invalidMail: false,
    trainee_training: "",
    tId: "",
    certificatetype: 0,
    checkList: {},
    mailtype: "certificate",
    mail_subject: "",
    mail_text: "",
    showMessage: false,
    attachments: [],
    logData: [],
    showLogDialog: false,
    activateLog: false,
    isOriginal: false,
    redirect: false,
    redirectLink: "",
  };
  componentDidMount() {
    this.props.authCheckState();
    axios.defaults.headers = {
      "Content-Type": "application/json",
      Authorization: `Token ${this.props.token}`,
    };
    this.setState({ loading: true });
    axios
      .get(mainLink + "/api/v1/traninigstype/")
      .then((res) => {
        this.setState({ loading: false });

        // let data = res.data.map(item => {
        // return item
        // })
        // console.log(data)
        // this.setState({
        //   data: data
        // })
      })
      .catch((err) => {
        this.setState({ loading: false });

        //          this.setState({ isErrorDialogPopUp: true, ErrorMessage: err.message });
      });
  }
  setRedirect = (link) => {
    this.state.redirectLink = link;
    this.setState({
      redirectLink: this.state.redirectLink,
      redirect: true,
    });
  };
  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirectLink} />;
    }
  };

  render() {
    let getActions = (actions = []) => {
      let act = [];
      for (let action of actions) {
        if (
          !this.props.permissions ||
          (this.props.permissions &&
            this.props.permissions.length &&
            this.props.permissions.indexOf(action.permission) >= 0)
        ) {
          act.push(action);
        }
      }
      return act;
    };
    if (this.state.activateLog) {
      axios.defaults.headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${this.props.token}`,
      };
      axios
        .get(
          window.location.origin +
            "/api/v1/traninigs/show_mail_log/?id=" +
            this.state.printId
        )
        .then((res) => {
          if ("data" in res.data) {
            this.setState({
              logData: res.data.data,
              showLogDialog: true,
            });
          } else {
            this.setState({
              isErrorDialogPopUp: true,
              ErrorMessage: res.data.message,
            });
          }
        })
        .catch((err) => {
          this.setState({
            isErrorDialogPopUp: true,
            ErrorMessage: err.message,
          });
        });
      this.setState({
        activateLog: false,
      });
    }
    const handleErrorClose = () => {
      this.setState({ isErrorDialogPopUp: false });
    };

    const handleSearchChange = (search) => {};
    return this.state.loading ? (
      <Fragment>
        <Loading />
      </Fragment>
    ) : (
      <Fragment>
        <Snackbar
          open={this.state.showMessage}
          autoHideDuration={6000}
          onClose={() => {
            this.setState({
              showMessage: false,
            });
          }}
        >
          <Alert
            onClose={() => {
              this.setState({
                showMessage: false,
              });
            }}
            severity="success"
          >
            सन्देश सफलतापूर्वक पठाइएको छ
          </Alert>
        </Snackbar>
        {this.renderRedirect()}
        <Dialog
          open={this.state.isErrorDialogPopUp}
          onClose={handleErrorClose}
          TransitionComponent={Transition}
          // PaperComponent={PaperComponent}
          aria-labelledby="draggable-dialog-title"
        >
          <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
            Error Message
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <span style={{ color: "red", fontSize: "small", marginLeft: 20 }}>
                {this.state.ErrorMessage}
              </span>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleErrorClose} color="primary" autoFocus>
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <MaterialTable
          tableRef={this.tableRef}
          title={
            <div style={{ fontSize: 20, fontWeight: "bold" }}>प्रशिक्षण</div>
          }
          columns={[
            {
              title: "परिचय नम्बर",
              field: "serial_number",
              emptyValue: "",
              // set width
              cellStyle: {
                width: "8%",
                maxWidth: "8%",
              },
            },
            {
              title: "प्रशिक्षण को नाम",
              field: "name_nepali",
              emptyValue: "",
            },
            {
              title: "प्रशिक्षण को नाम (अंग्रेजी)",
              field: "name_english",
            },
            {
              title: "प्रशिक्षण को प्रकार",
              field: "organization_type",
              render: (rowData) => {
                console.log(rowData.organization_type);
                return [
                  {
                    key: "सहकारी संस्था",
                    value: "cooperative-organization",
                  },
                  {
                    key: "नियामक निकाय",
                    value: "regulatory-body",
                  },
                  {
                    key: "अन्य",
                    value: "other",
                  },
                ]?.find((item) => item.value === rowData.organization_type)
                  ?.key;
              },
            },
          ]}
          data={(query) =>
            new Promise((resolve, reject) => {
              let url = "/api/v1/PaginationTrainingTypeView/?active=true&";
              url += "page_size=" + query.pageSize;
              url += "&page=" + (query.page + 1);
              url += "&ordering=-serial_number";
              if (query.search.length > 0) {
                url += "&search=" + query.search;
              }
              // console.log('print', query)
              fetch(url, {
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Token ${this.props.token}`,
                },
              })
                .then((response) => response.json())
                .then((result) => {
                  console.log(result);
                  let data = result.results.map((item) => {
                    return item;
                  });
                  // this.state.data = data
                  // this.state.page = query.page * query.pageSize
                  // this.state.total = result.total_data
                  resolve({
                    data: data,
                    page: query.page,
                    totalCount: result.count,
                  });
                  window.localStorage.setItem("current_book_page", query.page);
                });
            })
          }
          onSearchChange={handleSearchChange}
          options={{
            filtering: false,
            // search: false,
            exportButton: true,
            actionsColumnIndex: -1,
            emptyRowsWhenPaging: false,
            pageSize: 50,
            pageSizeOptions: [50, 100, 200],
            exportCsv: (columns, data) => {
              this.setState({ showCsvPrintDialog: true });
            },
          }}
          // editable={{
          //   onRowDelete: (oldData) =>
          //     new Promise((resolve, reject) => {
          //       const dataDelete = this.state.data;
          //       const index = oldData.tableData.id;
          //       this.setState({ loading: true });
          //       axios
          //         .delete(mainLink + `/api/v1/traninigstype/${oldData.id}/`)
          //         .then((res) => {
          //           dataDelete.splice(index, 1);
          //           this.setState([...dataDelete]);
          //           this.setState({ loading: false });
          //         })
          //         .catch((err) => {
          //           this.setState({ loading: false });

          //           //            //           this.setState({
          //             isErrorDialogPopUp: true,
          //             ErrorMessage: err.message,
          //           });
          //         });
          //       // console.log(index)
          //       resolve();
          //     }),
          // }}
          actions={getActions([
            {
              icon: () => <EditOutlinedIcon />,
              tooltip: "सम्पादन गर्नुहोस्",
              permission: "training-type-edit",
              onClick: (event, rowData) => {
                this.setRedirect(`/admin/training-type-edit/${rowData.id}`);
              },
            },
          ])}
          localization={{
            toolbar: {
              searchTooltip: "खोजी गर्नुहोस्",
              searchPlaceholder: "खोजी गर्नुहोस्",
              exportName: "डाउनलोड गर्नुहोस्",
            },
            header: {
              actions: "कार्यहरू",
            },
            body: {
              emptyDataSourceMessage: "कुनै रेकर्ड छैन",
              filterRow: {
                filterTooltip: "Filter",
              },
            },
          }}
          components={{
            Toolbar: (props) => (
              <div>
                <div style={{ padding: 20, paddingBottom: 0 }}>
                  <Tooltip title="प्रशिक्षक थप्नु" placement="top">
                    <Link
                      label="Chip 1"
                      color="secondary"
                      style={{ marginRight: 5, float: "right" }}
                      to="/admin/training-type-create/"
                    >
                      {this.props.permissions &&
                      this.props.permissions.length ? (
                        (!this.props.permissions ||
                          this.props.permissions.indexOf("training-type-add") >=
                            0) && <AddIcon style={{ fontSize: 40 }} />
                      ) : (
                        <AddIcon style={{ fontSize: 40 }} />
                      )}
                    </Link>
                  </Tooltip>
                </div>
                <MTableToolbar {...props} />
              </div>
            ),
            OverlayLoading: (props) => <div></div>,
          }}
        />
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  // console.log(state.book.categorys)
  return {
    editions: state.book.editions,
    token: state.auth.token,
    loading: state.book.loading,
    error: state.book.error,
    isAuthenticated: state.auth.token !== null,
    successAuth: state.auth.successAuth,
    permissions: state.auth.user["permissions"],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onPostBookEdition: (editionName, token) =>
      dispatch(postBookEdition(editionName, token)),
    onGetBookEdition: (token) => dispatch(getBookEdition(token)),
    ondeleteBookEdition: (editionId, token) =>
      dispatch(deleteBookEdition(editionId, token)),
    editBookEdition: (newEdition, editionId, token) =>
      dispatch(editBookEdition(newEdition, editionId, token)),
    authCheckState: () => dispatch(authCheckState()),
  };
};
export default compose(
  withStyles(useStyles, { withTheme: true }),
  connect(mapStateToProps, mapDispatchToProps)
)(Component);
